import { isSkorSdkMode } from "../../helper/skorSdk";
import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { Button, Modal } from "../design";
import "./SkorProtectActivatedPopup.css";

const SkorProtectActivatedPopup = ({ show, onDone }) => {
  const { _t } = useTranslator();

  if (!show) return null;

  return (
    <Modal
      open={show}
      onClose={onDone}
      dismissible={false}
      id="skor-protect-activated-popup"
      icon={
        <img src={SkorProtectShield} alt="" className="sp-activated-shield" />
      }
      title={_t("skorProtectIsNowActive")}
      description={_t("skorProtectActivatedNextSteps")}
      actions={
        <Button size="lg" block onClick={onDone}>
          {_t("gotIt")}
        </Button>
      }
    >
      <div className="sp-activated-points">
        <div className="sp-activated-point">
          <span className="sp-activated-point-icon">
            <CheckRoundedIcon />
          </span>
          <div>
            <h3>{_t("skorProtectCoverageConfirmed")}</h3>
            <p>{_t("skorProtectRentalAgreementUploaded")}</p>
          </div>
        </div>
        <div className="sp-activated-point">
          <span className="sp-activated-point-icon">
            <AccessTimeRoundedIcon />
          </span>
          <div>
            <h3>{_t("skorProtectPolicyIn24To48Hours")}</h3>
            <p>{_t("skorProtectPolicyAvailableInPropertyProfile")}</p>
          </div>
        </div>
      </div>
      {!isSkorSdkMode() && (
        <p className="sp-activated-support">
          {_t("haveAnyQuestions")}{" "}
          <a href="https://wa.me/34617662602" target="_blank" rel="noreferrer">
            {_t("contactUsOnWhatsApp")}
          </a>
        </p>
      )}
    </Modal>
  );
};

export default SkorProtectActivatedPopup;
